import { useEffect, useRef, useState } from "react";
import { func, string } from "prop-types";

import Tooltip from "../../../../shared/v2/Tooltip";

const TaskItemName = ({ onClick, name, className, ...otherProps }) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return undefined;
    const measure = () => setIsTruncated(el.scrollWidth > el.clientWidth);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [name]);

  return (
    <Tooltip
      placement="top"
      multiline
      className="tw-flex tw-flex-1 tw-min-w-0"
      content={isTruncated ? name : null}
      trigger={
        <button
          onClick={onClick}
          type="button"
          className="tw-grow tw-min-w-0 tw-text-left tw-border-0 tw-bg-transparent enabled:hover:tw-underline"
          {...otherProps}
        >
          <p ref={textRef} className="tw-truncate tw-m-0">
            {name}
          </p>
        </button>
      }
    />
  );
};

TaskItemName.propTypes = {
  onClick: func,
  name: string,
  className: string,
};

TaskItemName.defaultProps = {
  onClick: null,
  name: "",
  className: "",
};

export default TaskItemName;
